import React from 'react';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import theme from 'theme';

const FRContentDescription = ({ children }) => (
  <Typography
    style={{
      fontWeight: 400,
      fontSize: '0.875rem',
      color: theme.palette.black,
      minHeight: '2.5rem',
    }}
    gutterBottom>
    {children}
  </Typography>
);

FRContentDescription.propTypes = {
  children: PropTypes.string.isRequired,
};

export default FRContentDescription;
